import { render, staticRenderFns } from "./NormalSearchNav323.vue?vue&type=template&id=1a8ffdea&scoped=true&"
import script from "./NormalSearchNav323.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav323.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ffdea",
  null
  
)

export default component.exports